import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  TextField,
  CircularProgress,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { useTranslation } from "localization/translation";

const PlanPriceModal = ({
  title,
  accept,
  close,
  isOpen,
  loading,
  priceData,
  handleChangeData,
}) => {
  const translation = useTranslation();

  return (
    <Dialog
      classes={{
        paper: `modal-content rounded-lg`,
      }}
      open={isOpen}
      onClose={close}
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={accept}>
        <DialogTitle className="px-4">{title}</DialogTitle>
        <div className="px-4">
          <div className="my-3">
            <TextField
              id="outlined-basic"
              label={translation.price}
              variant="outlined"
              value={priceData.price}
              type="number"
              className="w-full"
              onChange={(e) => handleChangeData('price', e.target.value)}
            />
          </div>
          <div className="my-3">
            <FormControlLabel
              control={
                <div className="m-2">
                  <Switch
                    onClick={(e) => {
                      handleChangeData('active', e.target.checked);
                    }}
                    checked={!!priceData?.active}
                    className="switch-medium toggle-switch-first"
                  />
                </div>
              }
              label={!!priceData?.active ? translation.active : translation.inactive}
            />
          </div>
        </div>
        <DialogActions className="d-flex mx-auto p-4">
          <Button
            onClick={close}
            variant="contained"
            type="button"
            className=""
          >
            {translation.no}
          </Button>
          <Button
            color="secondary"
            type="submit"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : translation.yes}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PlanPriceModal;
